// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","modal":"modal-1-H6U","modal_mobileFullScreen":"modal_mobileFullScreen-3IAe8","modal__closeIcon":"modal__closeIcon-1xGyj"};